const Collections = () =>{
    return(
        <div className="collections">
            <div className="collection-boxes">
                <img src="images/image1.jpg" alt="" srcset="" />
            </div>
            <div className="collection-boxes">
                <img src="images/image2.jpg" alt="" srcset="" className="img3" />
            </div>
            <div className="collection-boxes">
                <img src="images/image3.jpg" alt="" srcset=""  className="img3"/>
            </div>
            <div className="collection-boxes-text">
                    <h6>New collection 2023</h6>
                    <h2>House shape <span>plants</span></h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. <br /> Alias repellendus architecto consequuntur impedit voluptatibus.   <br /> Omnis necessitatibus, eligendi atque, <br /> ullam ad dicta vitae ratione voluptas voluptatum rerum deleniti. <br /> Repellat, iure possimus?</p>
                    <a href="">Shop Now</a>
            </div>
        </div>
    )
}


export default Collections